// extracted by mini-css-extract-plugin
export var orderSummary = "_qh-0";
export var showMoreLessButton = "_qh-1";